import { useState, FC } from "react";

import { Alert, Table } from "react-bootstrap";

import { useQuery } from "@tanstack/react-query";
import { DateTime } from "luxon";

import { getServiceOrderTypeValuesByType } from "@/_constants/serviceOrder.ts";
import { getDateFromIso } from "@/_helpers/stringHelper.ts";
import { pagination } from "@/_helpers/tableHelper.ts";
import ColoredMarker from "@/common/components/ColoredMarker.tsx";

import Loader from "../../../../common/components/Loader";
import PaginationComponent from "../../../../common/components/PaginationComponent";
import ServiceStatusComponent from "../../../../common/components/ServiceStatusComponent";
import { ORDER_VIEW } from "../../../order/routes";
import { IService } from "../../../serviceOrdering/reducers";
import { IResponseServices } from "../../reducers";
import { getDwellingServices } from "../../services";

interface DwellingInterventionHistoryProps {
  dwellingId: string;
  needPagination?: boolean;
}

const DwellingInterventionHistoryTableComponent: FC<
  DwellingInterventionHistoryProps
> = ({ dwellingId, needPagination = true }) => {
  const [page, setPage] = useState(1);
  const { isLoading, error, data } = useQuery<IResponseServices, Error>(
    ["interventionsHistory", { page, dwellingId }],
    () => getDwellingServices(page, dwellingId)
  );

  if (isLoading) {
    return (
      <div className="bg-container">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-container">
        <Alert variant="danger">
          Erreur lors du chargement des historiques des interventions : {error}
        </Alert>
      </div>
    );
  }

  return (
    <>
      <Table className="border-none">
        <tbody className="border-none">
          {data?.services &&
            data?.services.length > 0 &&
            data.services.map((service: IService, index: number) => {
              const result = getServiceOrderTypeValuesByType(
                service.type as keyof object
              );

              const labelMin = result ? result.labelMin : "Inconnu(e)";
              const color = result ? result.color : "#000D5B";
              return (
                <tr className="border-none" key={index}>
                  <td className="text-start">
                    <ColoredMarker color={color}>{labelMin}</ColoredMarker>
                  </td>
                  <td className="text-start">
                    <ServiceStatusComponent
                      slug={
                        service?.appointment?.lastStatus?.status?.slug || ""
                      }
                    />
                  </td>
                  <td className="text-start dark-purple-text">
                    {getDateFromIso(
                      service?.appointment?.startDate,
                      DateTime.DATE_SHORT,
                      ""
                    )}
                  </td>
                  <td className="text-start dark-purple-text">
                    <a
                      href={ORDER_VIEW.replace(
                        ":id",
                        service.datedReference || service.id || ""
                      )}
                    >
                      Voir plus de détails
                    </a>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
      {needPagination && data?.services && data?.services.length > 0 && (
        <div className="navigationButtonWrapper">
          <PaginationComponent
            pages={pagination(data?.services?.length)}
            activePage={page}
            setActivePage={() => setPage((page) => page + 1)}
          />
        </div>
      )}
    </>
  );
};

export default DwellingInterventionHistoryTableComponent;
